module.exports = __webpack_public_path__ + "static/media/search.dafa8895.svg";